import { checkFieldExistence, clearFieldErrorArray } from '../../../AppConfig/actions';
import { change, Field, formValueSelector, getFormMeta, reduxForm } from 'redux-form';
import {
  getMasterData,
  getPayerInfoById,
  SavePayerInfo,
} from '../../actions';
import {
  isValidApartmentWithSpace,
  isValidName,
  isValidNameWithSpace,
  normalizeFax,
  normalizeMobile,
  normalizeZipCode,
  renderAutoCompleteSingleSelect,
  renderCheckBox,
  renderTextField,
  isInteger,
} from '../../../../components/reduxFields';
import { connect } from 'react-redux';
import { AMEGO, AMEGOFL, ARROWS, base64Encode, CONVERGENCY, displayCustomError, VIP } from '../../../../../src/actions/utilAction';
import { MODULE } from './../../constants/ApiConstants';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import React from 'react';
import validate from '../validate';
import Checkbox from 'material-ui/Checkbox';
import history from '../../../../history';
import Tooltip from 'material-ui/internal/Tooltip';
import {renderCustomRadioButtons} from "../../../../components/reduxFields";
import { flatMap } from 'lodash';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';


const stylescss = {
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
};

// const styles = {
//   font: {
//     fontStyle: 'ITALIC',
//   },
// };

const stylesRadio = {
  block: {
    maxWidth: 250,
  },
  radioButton: {
    marginBottom: 16,
  },
};


const renderCustomRadioInputes = ({
  input,
  name,
  label,
  options,
  meta: { touched, error },
  children,
  disabled,
  selectedValue,
  ...custom
}) => {
  let errorText = touched && error;
  return (
    <div>
      <RadioButtonGroup
        style={{display:"flex"}}
        {...input}
        name={name || ''}
        onChange={(e, value) => input.onChange(value)}
        valueSelected={selectedValue}>
          {renderRadioOptions(options, disabled)}
      </RadioButtonGroup>
      <div className="clearfix"></div>
      {errorText && (<div className='error'>
        {errorText}
      </div>)}
    </div>
  );
};


const renderRadioOptions = (options, disabled) => {
  if (options) {
    return options.map(function(obj) {
      return <RadioButton
        key={obj.id}
        value={obj.id}
        label={obj.value}
        disabled={disabled}
        style={stylesRadio.radioButton} />;
    });
  }
};

export const renderCheckBoxCustomSetting = ({ 
  input, 
  defaultChecked, 
  value,
   name, 
   label, 
   checked, 
   onChange, 
   className, 
   disabled, 
   meta: { touched, error },
   customError,
  }) => {
  let errorText = error;
  return( 
  <div>
  <Checkbox 
    {...input}
    name={name}
    errorText={error || customError}
    type="checkbox"
    value={input.name}
    className={className ? className : 'custm_check'}
    label={label}
    checked={input.value || checked ? true : false}
    onCheck={input.onChange}
    style={stylescss.checkbox}
    disabled={disabled ? disabled : false}
    floatingLabelStyle={{ color: '#7a7a7a' }}
    defaultChecked={defaultChecked}/>
    <div className="clearfix"></div>
      {errorText && (<div className='error'>
        {errorText}
      </div>)}
    </div>)
};


const validateJurisdictionEVV = (jurisdictionId) => {
  if (!jurisdictionId) {
    return 'Please select jurisdiction.';
  } else if (!Number.isInteger(jurisdictionId)) {
    return 'Please select an option.';
  }  
};
const validatePayerEVV = (payerEVVId) => {
  if (!payerEVVId) {
    return 'Please select payer.';
  } else if (!Number.isInteger(payerEVVId)) {
    return 'Please select an option.';
  }  
};
const validatePlanEVV = (planId) => {
  if (!planId) {
    return 'Please select plan.';
  } else if (!Number.isInteger(planId)) {
    return 'Please select an option.';
  }  
};
const validateProgramEVV = (programId) => {
  if (!programId) {
    return 'Please select program.';
  } else if (!Number.isInteger(programId)) {
    return 'Please select an option.';
  }  
};
const validateDeliverySystemEVV = (deliverySystemId) => {
  if (!deliverySystemId) {
    return 'Please select delivery system.';
  } else if (!Number.isInteger(deliverySystemId)) {
    return 'Please select an option.';
  }  
};

const validateProviderMedicaId = (providerMedicaidId) => {
  if (!providerMedicaidId || providerMedicaidId.trim() === '') {
    return 'Please enter NPI number';
  } else if (providerMedicaidId && providerMedicaidId.length < 8) {
    return 'Please enter valid NPI number';
  }
};
const validateTypeOfGrouping = (value) => !(value ? Number.isInteger(value.typesofGrouping) : value) ? 'Please select type of grouping' : undefined;
const validateOtherTaxonomy = (value) => !(value ? value.trim() : value) ? 'Please enter taxonomy code' : undefined;

class PayerInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activePayerId: null,
      saveAndContinueFlag: false,
      filteredStatesByCountry: [],
      masterState: [],
      masterCountry: [],
      masterInsuranceTypes: [],
      latitude: 0.0,
      longitude: 0.0,
      form1500PrintFormat: [{ id: 1, value: 'Normal' }, { id: 2, value: 'Pre-Printed' }],
      typesofGrouping:'',
      grouping_Setting:'',
      groupingOptions :[
        {id:1, value: 'Do Not Group Services'},
        { id: 2, value: 'Group Services with Identical Date of Service, Location, and CPT Codes into One Claim. (Same as Day Club by Provider)' },
        { id: 3, value: 'Group Services by Identical Date of Service and Location, Including All CPT Codes, on One Claim. (Same as Day Club by Provider w/ Same DOS)' },
        { id: 4, value: 'Group Services from Multiple Dates of Service at the Same Location, Including All CPT Codes, into One Claim. (New feature)' }
      ],
      dayClubByProvider:false,
      dayClubByProviderOnOneClaim:false,
      GroupServicesFromMultipleDatesOfServiceOnOneClaim:false,
      ClockInClockOutEVV:false,
      Taxonomylist: [{ id: '106S00000X', value: '106S00000X - BT' }, { id: '106E00000X', value: '106E00000X - BCaBA'  },{ id: '103K00000X', value: '103K00000X - BCBA'  },{ id: 'Other', value: 'Other' }],
      displayOtherTaxonomy: false,
    };

    this.checkPayerOptions = this.checkPayerOptions.bind(this);
    this.checkBox32Options = this.checkBox32Options.bind(this);
  }
  // changeIsTypeOfGrouping = (e, value) => {    
  //  console.log("value",e.target.value);
  // };

  componentWillMount() {
    this.props.getMasterData();
    if (this.props.payerId) {
      this.props.getPayerInfoById(this.props.payerId);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.master_data && nextProps.master_data !== this.props.master_data) {
      this.setState({
        masterCountry: nextProps.master_data.masterCountry,
        masterState: nextProps.master_data.masterState,
      }, () => {
        this.getFilteredPrimaryStatesList(this.props.initialValues.countryID);
      });
    }
    if (nextProps.initialValues && nextProps.initialValues.countryID && nextProps.initialValues.countryID !== this.props.initialValues.countryID) {
      this.getFilteredPrimaryStatesList(nextProps.initialValues.countryID);
    }

    // }
    // if (nextProps.payerId && this.state.saveAndContinueFlag === true) {
    //   this.props.handlePayerTabChange('1');
    // }

    if (nextProps.payerId !== this.props.payerId) {
      if (nextProps.payerId && this.state.saveAndContinueFlag) {
        this.setState({ saveAndContinueFlag: false });
        this.props.handlePayerTabChange('1');
      }
    }

    if (nextProps.save_payer_data && nextProps.save_payer_data !== this.props.save_payer_data) {
      let payerId = nextProps.save_payer_data.data && nextProps.save_payer_data.data.id;
      if (!this.props.payerId && payerId) {
        let payerIdEnc = base64Encode(`${payerId}`);
        history.push(`/payer/${payerIdEnc}`);
      } else if (this.state.saveAndContinueFlag) {
        this.setState({ saveAndContinueFlag: false });
        this.props.handlePayerTabChange('1');
      }
    }

    if (nextProps.activePayerInfo && nextProps.activePayerInfo !== this.props.activePayerInfo) {
      if (nextProps.activePayerInfo.data) {
        let data = nextProps.activePayerInfo.data;
        this.setState({
          address: nextProps.activePayerInfo.data.address,
          latitude: nextProps.activePayerInfo.data.latitude,
          longitude: nextProps.activePayerInfo.longitude,
          displayOtherTaxonomy: ((data.taxonomyCode !== '' && data.taxonomyCode !== undefined && data.taxonomyCode !== '106S00000X' && data.taxonomyCode !== '106E00000X' && data.taxonomyCode !== '103K00000X') ? true : false),
        }, () => { });
      }
    }

    if (this.props.payerName) {      
      this.props.setPayerName(this.props.payerName);
    }

  }

  _handleImageChange(e) {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      this.setState({
        userAvatar: reader.result,
      });
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  }


  handleRemoveImage = (e, type) => {
    e.preventDefault();
    this.setState({ userAvatar: '' });
  };

  onDateChange = (input, value) => {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  };

  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': (this.props.initialValues && this.props.initialValues.id) ? this.props.initialValues.id : 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };

  checkPayerOptions = (e, name) => {
    if (name === 'dayClubByProviderOnOneClaim' && e.target.checked) {      
      this.props.dispatch(change('PayerInfo', 'dayClubByProvider', false));
    } else if ((name === 'dayClubByProvider') && e.target.checked) {
      this.props.dispatch(change('PayerInfo', 'dayClubByProviderOnOneClaim', false));
    }
  }
  // checkPayerOptions = (e,id) => {
  //   this.setState({
  //     typesofGrouping: id
  //   })
  // }

  checkBox32Options = (e, name) => {
    if (name === 'leaveBox32Blank' && e.target.checked) {      
      this.props.dispatch(change('PayerInfo', 'leaveBox32BlankAlways', false));
    } else if ((name === 'leaveBox32BlankAlways') && e.target.checked) {
      this.props.dispatch(change('PayerInfo', 'leaveBox32Blank', false));
    }
  }

  checkEvvPayerOptions = (e, name) => {
    if(name === "isEVVPayer" && !this.props.isEVVPayer){
      this.props.dispatch(change("PayerInfo","dayClubByProvider", false));
      this.props.dispatch(change("PayerInfo","dayClubByProviderOnOneClaim", false));
    }
  }

  clockInAndClockOutEVVHandler = (e)=>{
    if(e.target.checked){
      this.setState({ClockInClockOutEVV:true}) 
    } 
    else this.setState({ClockInClockOutEVV:false})   
  }

  handleSaveContinue = (formData) => {
    this.onSubmit(formData);
    this.setState({ saveAndContinueFlag: true });
  };

  onSubmit = (formData) => {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    formData.id = this.props.payerId;
    formData['name'] = formData.name ? formData.name.trim() : null;    
    formData['isActive'] = formData.isActive ? true : false;
    formData['address'] = formData.address ? formData.address.trim() : null;    
    formData['city'] = formData.city ? formData.city.trim() : null;    
    formData['additionalClaimInfo'] = formData.additionalClaimInfo ? formData.additionalClaimInfo.trim() : null;        
    formData['billingAddress'] = formData.billingAddress ? formData.billingAddress.trim() : null;    
    formData['billingCity'] = formData.billingCity ? formData.billingCity.trim() : null;        
    formData['taxonomyCode'] = this.state.displayOtherTaxonomy ? (formData.taxonomyCode ? formData.taxonomyCode.trim() : '') : (formData.taxonomyCodeIds || ''); 
    formData['billingProviderInfo'] = formData.billingProviderInfo ? formData.billingProviderInfo.trim() : null;  
    // formData.dayClubByProvider = this.state.dayClubByProvider ? this.state.dayClubByProvider : false;
    // formData.dayClubByProviderOnOneClaim = this.state.dayClubByProviderOnOneClaim ? this.state.dayClubByProviderOnOneClaim : false;
    // formData.GroupServicesFromMultipleDatesOfServiceOnOneClaim = this.state.GroupServicesFromMultipleDatesOfServiceOnOneClaim ? this.state.GroupServicesFromMultipleDatesOfServiceOnOneClaim : false;
    formData['latitude'] = this.state.latitude;
    formData['longitude'] = this.state.longitude;
    let optionNumber = formData['grouping_Setting'];
    // let DayClubByProvider = false;
    // let DayClubByProviderOnOneClaim = false;
    // let GroupServicesFromMultipleDatesOfServiceOnOneClaim = false;

    // if(optionNumber == 2){
    //   DayClubByProvider = true;
    // }else if(optionNumber == 3){
    //   DayClubByProviderOnOneClaim = true;
    // }else if(optionNumber == 4){
    //   GroupServicesFromMultipleDatesOfServiceOnOneClaim = true;
    // }
    
   let  ClockInAndClockOutEVV = this.state.ClockInClockOutEVV
    let obj = {
      ...formData,
      // DayClubByProvider,
      // DayClubByProviderOnOneClaim,
      // GroupServicesFromMultipleDatesOfServiceOnOneClaim,
      ClockInAndClockOutEVV
    }
    this.props.SavePayerInfo(obj);
  };

  handleNewRequest = (input, selectedRecord) => {
    if (input.name === ('countryID')) {
      this.getFilteredPrimaryStatesList(selectedRecord.value);
    } else if (input.name === 'taxonomyCodeIds') {
      if (selectedRecord.value !== '') {
        if (selectedRecord.value === 'Other') {          
          this.props.dispatch(change('LocationMasterModalForm', 'taxonomyCode', null));
          this.setState({ displayOtherTaxonomy: true });
        } else {          
          this.props.dispatch(change('PayerInfo', 'taxonomyCode', null));
          this.setState({ displayOtherTaxonomy: false });
        }
      } else {
        
        this.setState({ displayOtherTaxonomy: false });
      }
    }
    input.onChange(selectedRecord.value);
  };

  getFilteredPrimaryStatesList = (countryID) => {
    if (this.state.masterState) {
      let allStates = this.state.masterState;
      let filteredStates = allStates.filter((Obj) => Obj.countryID === countryID);
      this.setState({ filteredStatesByCountry: filteredStates });
    }
  };

  checkCustomSignatureSetting = (e, name) => {
    if(!this.props.isCustomSignatureSetting){
      this.props.dispatch(change("PayerInfo","requiredStaffSignature", false));
      this.props.dispatch(change("PayerInfo","requiredGuardianSignature", false));
      this.props.dispatch(change("PayerInfo","requiredSupervisingClinicianSignature", false));
      this.props.dispatch(change("PayerInfo","doNotRequiredAnySignature", false));
    }
  }

  checkDoNotRequireAnySignature = (e, name) => {
    if( name == "doNotRequiredAnySignature" && !this.props.isDoNotRequireAnySignature){
      this.props.dispatch(change("PayerInfo","requiredStaffSignature", false));
      this.props.dispatch(change("PayerInfo","requiredGuardianSignature", false));
      this.props.dispatch(change("PayerInfo","requiredSupervisingClinicianSignature", false));
    }
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <div>
        <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
          <div className="row">
            <div className="col-sm-4 require mt-35">
              <Field
                name="insuranceTypeId"
                label="Insurance Type"
                options={this.props.masterInsuranceType ? this.props.masterInsuranceType : []}
                handleNewRequest={this.handleNewRequest}
                component={renderAutoCompleteSingleSelect}
              />
            </div>
            <div className="col-sm-4 require">
              <Field
                name="name"
                type="text"
                label="Payer Name"
                maxLength="50"
                onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Payer name')}
                customError={displayCustomError('NAME', this.props.fieldError_Payername)}
                normalize={isValidNameWithSpace}
                component={renderTextField} />
            </div>
            <div className="col-sm-4">
              <Field
                name="tplCode"
                type="text"
                label="TPL Code"
                normalize={isValidName}
                maxLength="20"
                component={renderTextField} />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <Field
                name="carrierPayerID"
                type="text"
                maxLength="10"
                normalize={isValidName}
                label="Carrier Payer Id"
                component={renderTextField} />
            </div>
            <div className="col-sm-4">
              <Field
                name="email"
                type="text"
                label="Email"
                maxLength="60"
                onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Email')}
                customError={displayCustomError('EMAIL', this.props.fieldError_Email)}
                component={renderTextField} />
            </div>
            <div className="col-sm-4">
              <Field
                name="phone"
                type="text"
                label="Phone"
                maxLength="14"
                normalize={normalizeMobile}
                component={renderTextField} />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <Field
                name="fax"
                normalize={normalizeFax}
                type="text"
                maxLength='14'
                label="Fax"
                component={renderTextField} />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-8 require">
              <Field
                name="address"
                type="text"
                maxLength="55"
                label="Address"
                // normalize = {isValidNameWithSpace}
                fullWidth={true}
                component={renderTextField}/>
            </div>
            <div className="col-sm-4">
              <Field
                name="apartmentNumber"
                type="text"
                maxLength='15'
                label="Apt/Unit"
                normalize={isValidApartmentWithSpace}
                component={renderTextField} />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4 require mt-35">
              <Field
                name="countryID"
                label="Country"
                ref="countryID"
                // value={this.state.country}
                options={this.state.masterCountry}
                handleNewRequest={this.handleNewRequest}
                component={renderAutoCompleteSingleSelect} />
            </div>
            <div className="col-sm-4 require">
              <Field
                name="city"
                type="text"
                label="City"
                maxLength='50'
                normalize={isValidNameWithSpace}
                component={renderTextField} />
            </div>
            <div className="col-sm-4 require mt-35">
              <Field
                name="stateID"
                label="State"
                disabled={!this.props.countryID}
                options={this.state.filteredStatesByCountry}
                handleNewRequest={this.handleNewRequest}
                component={renderAutoCompleteSingleSelect} />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4 require">
              <Field
                name="zip"
                type="text"
                //normalize={normalizeZipCode}
                maxLength={10}
                label="Zip Code"
                component={renderTextField} />
            </div>
            <div className="col-sm-4">
              <Field
                name="box17AQualifier"
                type="text"
                normalize={isValidNameWithSpace}
                maxLength={2}
                label="Box 17A Qualifier"
                component={renderTextField} />
            </div>
            <div className="col-sm-4"></div>
            {/* <div className="col-sm-4">
              <Field
                  name="taxonomyCode"
                  type="text"
                  maxLength='100'
                  label="Billing Provider Taxonomy Code"                    
                  component={renderTextField} />
            </div>
            <div className="col-sm-4">
                  <Field
                    name="billingTaxId"
                    label="Billing Tax ID #(Professional)"
                    maxLength='9'
                    component={renderTextField}
                    normalize={isInteger}
                  />
            </div> */}
          </div>
          <div className="row">
            {/* <div className="row">
              <div className='col-sm-12 mt-35'>
                <div className="mb-20">
                  <div style={{display:"flex",justifyContent:"space-between"}}>
                    <div style={{
                      display: "flex",
                      alignItems: "baseline",
                      justifyContent: "space-between"}}>
                      <strong>Grouping Settings :</strong>
                    </div>
                    <div>
                      <small>
                        <a href='https://theralytics.freshdesk.com/support/home' target='_blank'>Do you need help?</a>
                      </small>
                    </div>
                  </div>
                  <div className='mt-2'>
                    <em>
                      If one of the grouping options is selected, Theralytics will combine units from multiple service lines into one service line only when they have the same CPT code, modifier, location code, and rendering provider.
                    </em>
                  </div>
                  <div className='mt-4'>
                    <div className="">
                      <Field name="grouping_Setting"
                        options={this.state.groupingOptions}
                        component={renderCustomRadioInputes}
                        onChange={this.checkPayerOptions}
                        selectedValue={this.state.typesofGrouping? this.state.typesofGrouping:this.props.grouping_Setting}
                        validate={this.state.isFormSubmitted && this.state.typesofGrouping === 0 ? [validateTypeOfGrouping] : null}
                        />
                    </div>
                  </div>
                </div>
              </div>
            </div>    */}
            {/* <div className='d-flex flex-row justify-content-around'> */}
              
            {/* </div> */}

            <div className="col-sm-4 mt-40">
              <Field
                name="dayClubByProvider"
                label="Day Club By Provider"
                component={renderCheckBox}
                style={stylescss.checkbox}
                disabled={this.props.isEVVPayer}
                onChange={(e) => this.checkPayerOptions(e, 'dayClubByProvider')}
              />
            </div>  
            <div className="col-sm-4 mt-40">
              <Field
                name="isEDIPayer"
                label="EDI Payer"
                component={renderCheckBox}
                style={stylescss.checkbox}
              />
            </div>
            <div className="col-sm-4 mt-40">
              <Field
                name="isPractitionerIsRenderingProvider"
                label="Practitioner Is Rendering Provider"
                component={renderCheckBox}
                style={stylescss.checkbox}
              />
            </div>            
          </div>
          <div className="row">
            <div className='col-sm-4 require mt-40'>
              <Field
                name="form1500PrintFormat"
                label="Print Formats"
                options={this.state.form1500PrintFormat}
                handleNewRequest={this.handleNewRequest}
                component={renderAutoCompleteSingleSelect} />
            </div>
            <div className="col-sm-4 mt-40">
              <Field
                name="isTricare"
                label="Tricare"
                component={renderCheckBox}
                style={stylescss.checkbox}
                //onChange={(e) => this.checkPayerOptions(e, 'isTricare')}
              />
            </div>
            <div className="col-sm-4 mt-40">
              <Field
                name="addCountyCodeInBox19"
                label="Add County Code in Box 19 (Form 1500)"
                component={renderCheckBox}
                style={stylescss.checkbox}
                maxLength='60'
                //onChange={(e) => this.checkPayerOptions(e, 'isAddCountyCodeInBox19')}
              />
            </div>            
          </div>
          <div className="row">
            <div className="col-sm-4 mt-40">
              <Field
                name="isActive"
                label="Active"
                disabled={true}
                component={renderCheckBox}
                style={stylescss.checkbox}
              />
            </div>            
            <div className="col-sm-4 mt-40">
              <Field
                name="dayClubByProviderOnOneClaim"
                label="Day Club by provider w/ same DOS on one claim"
                component={renderCheckBox}
                style={stylescss.checkbox}
                disabled={this.props.isEVVPayer}
                onChange={(e) => this.checkPayerOptions(e, 'dayClubByProviderOnOneClaim')}
              />                
            </div> 
            {this.props.agencyName.toUpperCase() === AMEGO || this.props.agencyName.toUpperCase() === AMEGOFL || this.props.agencyName.toUpperCase() === VIP ?      
            <div className="col-sm-4 mt-40">
              <Field
                name="isDPHPayer"
                label="DPH Payer"
                component={renderCheckBox}
                style={stylescss.checkbox}                
              />     
              </div>: null}       
            {this.props.agencyName.toUpperCase() === VIP || this.props.agencyName.toUpperCase() === 'ABCSPECTRUM' ?          
            <div className="col-sm-4 mt-40">
              <Field
                name="isLACarePayer"
                label="LA Care Payer"
                component={renderCheckBox}
                style={stylescss.checkbox}                
              />     
              </div>: null}  
             {this.props.agencyName.toUpperCase() === ARROWS ?          
              <div className="col-sm-4 mt-40">
                <Field
                  name="isMedicaidIdOverridingRenderingNPI"
                  label="Add Medicaid ID on Claim (Box 24J)"
                  component={renderCheckBox}
                  style={stylescss.checkbox}                
                />     
                </div>: null} 
                <div className="col-sm-4 mt-40">
                  <Field
                    name="leaveBox32Blank"
                    label="Box 32 should be blank if address and NPI are the same as Box 33"
                    component={renderCheckBox}
                    style={stylescss.checkbox}
                    onChange={(e) => this.checkBox32Options(e, 'leaveBox32Blank')}
                  />
                </div>                 
                <div className="col-sm-4 mt-40">
                  <Field
                    name="leaveBox32BlankAlways"
                    label="Only display address in Box 32 if location code is 11"
                    component={renderCheckBox}
                    style={stylescss.checkbox}
                    onChange={(e) => this.checkBox32Options(e, 'leaveBox32BlankAlways')}
                  />
                </div>
                <div className="col-sm-4 mt-40">
                  <Field
                    name="sendOrderingProviderNPIInEDIClaim"
                    label="Send ordering provider NPI in EDI claim (use same # as referring)"
                    component={renderCheckBox}
                    style={stylescss.checkbox}                    
                  />
                </div>
                {this.props.agencyName.toUpperCase() === VIP && <div className="col-sm-4 mt-40 payer">
                  <Field
                    name="isEVVPayer"
                    label="EVV Payer"
                    component={renderCheckBox}
                    style={stylescss.checkbox}
                    onChange={(e) => this.checkEvvPayerOptions(e, 'isEVVPayer')}
                  /> 
                  {this.props.isEVVPayer && (
                    <span className="error-message" style={{ color: "rgb(244, 67, 54)", fontSize: "12px" }}>
                      This is an EVV Payer. Day Club settings cannot be applied. To apply Day Club settings, please uncheck the EVV Payer setting.</span>
                  )}   
                  <span><Tooltip Description='Only applicable for Florida Medicaid. Please contact support and request an EVV training prior to checking this box' /></span>             
                </div>}
                {/* <div className="col-sm-4 mt-40">
                  <Field
                    name="clockInAndClockOutEVV"
                    label= "Clock-in/Clock-Out EVV"
                    component={renderCheckBox}
                    onChange={(e)=>this.clockInAndClockOutEVVHandler(e)}
                    style={stylescss.checkbox}
                    disabled = {this.state.isEvvPayer}
                    checked = {this.state.isEvvPayer || this.state.ClockInClockOutEVV}                    
                  />
                </div>             */}
          </div>
          { this.props.isEVVPayer ?
          <div className="row">
            <div className="col-sm-4 require mt-35">
              <Field
                name="jurisdictionId"
                label="Jurisdiction"                
                options={this.props.masterJurisdictionEVV}
                handleNewRequest={this.handleNewRequest}
                validate={this.props.isEVVPayer ? validateJurisdictionEVV : null}
                component={renderAutoCompleteSingleSelect} />
            </div>
            <div className="col-sm-4 require mt-35">
              <Field
                name="payerEVVId"
                label="Payer"                
                options={this.props.masterPayerEVV}
                handleNewRequest={this.handleNewRequest}
                validate={this.props.isEVVPayer ? validatePayerEVV : null}
                component={renderAutoCompleteSingleSelect} />
            </div>
            <div className="col-sm-4 require mt-35">
              <Field
                name="planId"
                label="Plan"                
                options={this.props.masterPlanEVV}
                handleNewRequest={this.handleNewRequest}
                validate={this.props.isEVVPayer ? validatePlanEVV : null}
                component={renderAutoCompleteSingleSelect} />
            </div>           
          </div>
          : null} 
          {this.props.isEVVPayer ?
          <div className="row">
            <div className="col-sm-4 require mt-35">
              <Field
                name="programId"
                label="Program"                
                options={this.props.masterProgramEVV}
                handleNewRequest={this.handleNewRequest}
                validate={this.props.isEVVPayer ? validateProgramEVV : null}
                component={renderAutoCompleteSingleSelect} />
            </div>
            <div className="col-sm-4 require mt-35">
              <Field
                name="deliverySystemId"
                label="Delivery System"                
                options={this.props.masterDeliverySystemEVV}
                handleNewRequest={this.handleNewRequest}
                validate={this.props.isEVVPayer ? validateDeliverySystemEVV : null}
                component={renderAutoCompleteSingleSelect} />
            </div>
            <div className="col-sm-4 require">
              <Field
                name="providerMedicaidId"
                type="text"
                maxLength="10"
                normalize={isValidNameWithSpace}
                label="Provider Medicaid Id"
                validate={this.props.isEVVPayer ? validateProviderMedicaId : null}
                component={renderTextField} />
            </div>
          </div>
          : null }
          <div className="row">
              <div className="col-sm-12 mt-40">
                <Field
                    name="additionalClaimInfo"
                    type="text"
                    label="Additional Claim Info (Box 19 Form 1500)"
                    maxLength='60'
                    component={renderTextField} />
              </div>
          </div> 
          <div className="row">
            <Field
              name="customSignatureSettings"
              label={
                <div>
                  Custom signature settings
                  <em style={{ fontSize: "0.9em",marginLeft: "5px" }}>
                   (If 'Custom signature settings' is not selected, then the system will use the settings from the configuration area.)
                  </em>
                </div>
              }
              component={renderCheckBoxCustomSetting}
              style={stylescss.checkbox}
              onChange={(e) => this.checkCustomSignatureSetting()}
            />
          </div>     
            {this.props.isCustomSignatureSetting ?
              <div style={{marginLeft : "20px"}}>
                <div>
                  <Field
                  name="requiredStaffSignature"
                  label="Require staff signature for non-billable and billable session notes"
                  component={renderCheckBox}
                  style={stylescss.checkbox}
                  disabled = {this.props.isDoNotRequireAnySignature}
                  />
                </div> 
                <div>
                  <Field
                  name="requiredGuardianSignature"
                  label="Require parent/guardian signature for billable session notes"
                  component={renderCheckBox}
                  style={stylescss.checkbox}
                  disabled = {this.props.isDoNotRequireAnySignature}
                  />
                </div> 
                <div>
                  <Field
                  name="requiredSupervisingClinicianSignature"
                  label="Require supervising clinician signature for billable session notes"
                  component={renderCheckBox}
                  style={stylescss.checkbox}
                  disabled = {this.props.isDoNotRequireAnySignature}
                  />
                </div> 
                <div>
                  <Field
                  name="doNotRequiredAnySignature"
                  label="Do not require any signatures for non-billable and billable session notes"
                  component={renderCheckBox}
                  style={stylescss.checkbox}
                  onChange={(e) => this.checkDoNotRequireAnySignature(e, 'doNotRequiredAnySignature')}
                  />
                </div> 
              </div>
              : null}
          <div className="row">
            <div className="col-sm-12">
              <div className="panel_title">
                <h3>Billing Provider Section</h3>
                <i className="flaticon flaticon-medical-4"></i>
              </div>
            </div>
            <div className="col-sm-12">
              <Field
                name="billingAddress"
                type="text"
                maxLength="55"
                label="Address"
                // normalize = {isValidNameWithSpace}
                fullWidth={true}
                component={renderTextField}/>
            </div>
            <div className="col-sm-4">
              <Field
                name="billingApartmentNumber"
                type="text"
                maxLength='15'
                label="Apt/Unit"
                normalize={isValidApartmentWithSpace}
                component={renderTextField} />
            </div>                  
            <div className="col-sm-4 mt-35">
              <Field
                name="billingCountryID"
                label="Country"
                handleNewRequest={this.handleNewRequest}
                options={this.state.masterCountry}
                component={renderAutoCompleteSingleSelect}/>
            </div>
            <div className="col-sm-4">
              <Field
                name="billingCity"
                type="text"
                label="City"
                maxLength='50'
                normalize={isValidNameWithSpace}
                component={renderTextField} />
            </div>
            <div className="col-sm-4 mt-35">
              <Field
                name="billingStateID"
                label="State"
                handleNewRequest={this.handleNewRequest}
                options={this.state.filteredStatesByCountry}
                component={renderAutoCompleteSingleSelect} />
            </div>                  
            <div className="col-sm-4">
              <Field
                name="billingZip"
                type="text"
                //normalize={normalizeZipCode}
                maxLength={10}
                label="Zip Code"
                component={renderTextField} />
            </div>
            <div className="col-sm-6 mt-35">
                <Field
                  name="taxonomyCodeIds"
                  label="Taxonomy Code"
                  handleNewRequest={this.handleNewRequest}
                  options={this.state.Taxonomylist}
                  component={renderAutoCompleteSingleSelect} />
            </div>
            {this.state.displayOtherTaxonomy && 
            <div className="col-sm-4 require">
              <Field
                  name="taxonomyCode"
                  type="text"
                  maxLength='100'
                  label="Billing Provider Taxonomy Code"                    
                  component={renderTextField}                  
                  validate={this.state.displayOtherTaxonomy ? [validateOtherTaxonomy] : null}
                  />
            </div>}
            <div className="col-sm-4">
                  <Field
                    name="billingTaxId"
                    label="Billing Tax ID #(Professional)"
                    maxLength='9'
                    component={renderTextField}
                    normalize={isInteger}
                  />
            </div>   
            <div className="col-sm-8">
              <Field
                name="billingProviderInfo"
                label="Billing Provider Name"
                type="text"
                maxLength="250"
                // normalize ={isValidNameWithSpace}
                component={renderTextField}
              />
            </div>
          </div>
          {/* {this.props.agencyName.toUpperCase().startsWith(EBS) ?      
          <div className="row">
            <div className="col-sm-4 mt-40">
              <Field
                name="isPractitionerSignRequired"
                label="Practitioner sign required to complete SOAP"
                component={renderCheckBox}
                style={stylescss.checkbox}
              />
            </div>
            <div className="col-sm-4 mt-40">
              <Field
                name="isGuardianSignRequired"
                label="Guardian sign required to complete SOAP"
                component={renderCheckBox}
                style={stylescss.checkbox}
              />
            </div>
            <div className="col-sm-4 mt-40">
              <Field
                name="isRenderingProviderSignRequired"
                label="Supervising clinician sign required to complete SOAP"
                component={renderCheckBox}
                style={stylescss.checkbox}
              />
            </div>
          </div>
          : null} */}
          <div className="row">
            <div className="col-sm-12 pt20 btn_rt">
              <RaisedButton type="submit" primary={true} label="Save"></RaisedButton>
              <RaisedButton className="ml_15" onClick={handleSubmit(this.handleSaveContinue.bind(this))} primary={true} label="Save & Continue" />
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const selector = formValueSelector('PayerInfo');

const mapStateToProps = (state, ownProps) => {
  let payerName = null;
  let grouping_Setting = 1;
  let initialData = {};
  let agencyName = state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '';
  let countryName = agencyName.toUpperCase() === CONVERGENCY ? 'Canada' : 'US';

  if (ownProps.payerId && state.payer.get_payer_data_by_id && state.payer.get_payer_data_by_id.data) {
    payerName = state.payer.get_payer_data_by_id.data.name;

    initialData = state.payer.get_payer_data_by_id.data;
    if(state.payer.get_payer_data_by_id.data.taxonomyCode !== '' && state.payer.get_payer_data_by_id.data.taxonomyCode !== undefined && state.payer.get_payer_data_by_id.data.taxonomyCode !== '106S00000X' && state.payer.get_payer_data_by_id.data.taxonomyCode !== '106E00000X' && state.payer.get_payer_data_by_id.data.taxonomyCode !== '103K00000X') 
    {
      initialData.taxonomyCode = state.payer.get_payer_data_by_id.data.taxonomyCode;
      initialData.taxonomyCodeIds = 'Other';
    }
    else {      
      initialData.taxonomyCodeIds = state.payer.get_payer_data_by_id.data.taxonomyCode;
    }    
  } else {
    initialData['isActive'] = true;
    initialData['isEDIPayer'] = true;
    initialData['form1500PrintFormat'] = 1;
    initialData['countryID'] = state.payer.master_data && state.payer.master_data.masterCountry ? state.payer.master_data.masterCountry.filter((obj) => obj.countryName === countryName)[0].id : [];
  }
  let fieldError_Payername = null;
  let fieldError_Email = null;

  if (state.appConfig && state.appConfig.fieldError) {
    fieldError_Payername = state.appConfig.fieldError.filter((obj, i) => obj.data === 'NAME');
    fieldError_Email = state.appConfig.fieldError.filter((obj, i) => obj.data === 'EMAIL');
  }

  let masterJurisdictionEVV = [], masterPayerEVV = [], masterPlanEVV = [], masterProgramEVV = [], masterDeliverySystemEVV = [];

  if(state.payer.master_data && state.payer.master_data.masterEVVDetails)
  {
    masterJurisdictionEVV = state.payer.master_data && state.payer.master_data.masterEVVDetails ? state.payer.master_data.masterEVVDetails.filter((obj) => obj.category === 'JURISDICTION' && obj.rendSvsSupported === 'Yes') : [];
    masterPayerEVV = state.payer.master_data && state.payer.master_data.masterEVVDetails ? state.payer.master_data.masterEVVDetails.filter((obj) => obj.category === 'PAYER' && obj.rendSvsSupported === 'Yes') : [];
    masterPlanEVV = state.payer.master_data && state.payer.master_data.masterEVVDetails ? state.payer.master_data.masterEVVDetails.filter((obj) => obj.category === 'PLAN' && obj.rendSvsSupported === 'Yes') : [];
    masterProgramEVV = state.payer.master_data && state.payer.master_data.masterEVVDetails ? state.payer.master_data.masterEVVDetails.filter((obj) => obj.category === 'PROGRAM') : [];
    masterDeliverySystemEVV = state.payer.master_data && state.payer.master_data.masterEVVDetails ? state.payer.master_data.masterEVVDetails.filter((obj) => obj.category === 'DELIVERYSYSTEM' && obj.rendSvsSupported === 'Yes') : [];
  } 
  
  // if(state.payer && state.payer.get_payer_data_by_id && state.payer.get_payer_data_by_id.data && state.payer.get_payer_data_by_id.data.dayClubByProvider){
  //   initialData["grouping_Setting"] = 2
  //   grouping_Setting = 2;
  // }else if(state.payer && state.payer.get_payer_data_by_id && state.payer.get_payer_data_by_id.data && state.payer.get_payer_data_by_id.data.dayClubByProviderOnOneClaim){
  //   initialData["grouping_Setting"] = 3
  //   grouping_Setting = 3;
  // }else if(state.payer && state.payer.get_payer_data_by_id && state.payer.get_payer_data_by_id.data && state.payer.get_payer_data_by_id.data.groupServicesFromMultipleDatesOfServiceOnOneClaim){
  //   initialData["grouping_Setting"] = 4
  //   grouping_Setting = 4;
  // }

  return {
    save_payer_data: state.payer.save_payer_data,
    masterInsuranceType: state.payer.master_data.masterInsuranceType || [],
    formMeta: getFormMeta('PayerInfoForm')(state),
    initialValues: initialData,
    activePayerInfo: state.payer.get_payer_data_by_id,
    isEVVPayer:  selector(state, 'isEVVPayer'),
    isCustomSignatureSetting : selector(state, 'customSignatureSettings'),
    isDoNotRequireAnySignature : selector(state,'doNotRequiredAnySignature'),
    payerAdded: state.payer.payerAdded,
    master_data: state.payer.master_data,
    countryID: selector(state, 'countryID'),
    fieldError_Payername: fieldError_Payername,
    fieldError_Email: fieldError_Email,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    masterJurisdictionEVV: masterJurisdictionEVV,
    masterPayerEVV: masterPayerEVV,
    masterPlanEVV: masterPlanEVV,
    masterProgramEVV: masterProgramEVV,
    masterDeliverySystemEVV: masterDeliverySystemEVV,
    payerName: payerName,
    grouping_Setting
  };
};

PayerInfo = reduxForm({
  form: 'PayerInfo',
  validate,
  enableReinitialize: true,
})(PayerInfo);


export default connect(mapStateToProps, { checkFieldExistence, clearFieldErrorArray, getMasterData, SavePayerInfo, getPayerInfoById })(PayerInfo);



// WEBPACK FOOTER //
// ./src/modules/Payers/containers/payerModule/information_old.js